import { render, staticRenderFns } from "./LeftPostBasic.vue?vue&type=template&id=361ba88d&scoped=true&"
import script from "./LeftPostBasic.vue?vue&type=script&lang=js&"
export * from "./LeftPostBasic.vue?vue&type=script&lang=js&"
import style0 from "./LeftPostBasic.vue?vue&type=style&index=0&id=361ba88d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ba88d",
  null
  
)

export default component.exports